import Navigation from "@/components/Navigation";
import Hero from "@/components/Hero";
import Showreel from "@/components/Showreel";
import Services from "@/components/Services";
import Cases from "@/components/Cases";
import LocationsMap from "@/components/LocationsMap";
import Lichtspiel from "@/components/Lichtspiel";
import KiTeaser from "@/components/KiTeaser";
import Partners from "@/components/Partners";
import InstagramHub from "@/components/InstagramHub";
import About from "@/components/About";
import OriginStory from "@/components/OriginStory";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import Chatbot from "@/components/Chatbot";
import SEOHead from "@/components/SEOHead";

const HomePage = () => {
  return (
    <div className="min-h-screen">
      <SEOHead />
      <Navigation />
      <div id="hero">
        <Hero />
      </div>
      <Services />
      {/* KI direkt nach den Services — der Differenzierer soll früh sichtbar sein,
          nicht erst nach 6 Sektionen. */}
      <KiTeaser />
      <div id="cases">
        <Cases />
      </div>
      <Lichtspiel />
      <LocationsMap />
      <Partners />
      <InstagramHub />
      <div id="about">
        <About />
      </div>
      <OriginStory />
      <Showreel />
      <div id="contact">
        <Contact />
      </div>
      <Footer />
      <Chatbot />
    </div>
  );
};

export default HomePage;
